import { useState } from "react";

import { TwoFactorAuthenticationMethods } from "@shared/types/graphqlGenerated.d";
import { TwoFactorAuthenticationForm } from "@unauthenticated/shared/components";
import { SignInBlock } from "@unauthenticated/shared/components/SignInBlock";
import { SignInLayout } from "@unauthenticated/signupSignin/components";

interface Props {
  additionalAttributes?: any;
  ssoErrors?: string;
  authErrors?: string;
}

const SignInPage = (props: Props) => {
  const [isShowTwoFactorFlow, setIsShowTwoFactorFlow] = useState(false);
  const [loginEmail, setLoginEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [twoFactorAuthToken, setTwoFactorAuthToken] = useState("");
  const [isLockedOut, setIsLockedOut] = useState(false);
  const [userOtpMethod, setUserOtpMethod] = useState<TwoFactorAuthenticationMethods>(
    TwoFactorAuthenticationMethods.Email
  );

  const handleShowTwoFactorFlow = ({ otpMethod, userEmail, phoneLast4, authToken }) => {
    setIsShowTwoFactorFlow(true);
    setTwoFactorAuthToken(authToken);
    setUserOtpMethod(otpMethod);
    setLoginEmail(userEmail);
    setPhone(phoneLast4);
  };

  const handleBackToSignIn = () => {
    setIsShowTwoFactorFlow(false);
  };

  const handleUserLockedOut = () => {
    setIsLockedOut(true);
    handleBackToSignIn();
  };

  const renderForm = () => {
    if (isShowTwoFactorFlow) {
      return (
        <TwoFactorAuthenticationForm
          userEmail={loginEmail}
          phoneLast4={phone}
          otpMethod={userOtpMethod}
          twoFactorAuthToken={twoFactorAuthToken}
          onBackToSignIn={handleBackToSignIn}
          onUserLockedOut={handleUserLockedOut}
        />
      );
    }

    return (
      <SignInBlock
        {...props}
        onShowTwoFactorFlow={handleShowTwoFactorFlow}
        isLockedOut={isLockedOut}
      />
    );
  };

  return <SignInLayout>{renderForm()}</SignInLayout>;
};

export { SignInPage };
